<template>
  <div class="app-container">
    <header>
      <div class="header-content">
        <div class="logo-section">
          <img v-if="theme" src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/logo.png" alt="待加载" @click="gohome">
          <img v-else src="https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/System_Default/dark_logo.png" alt="待加载" @click="gohome">
        </div>

        <!-- GPU 实时监控 -->
        <gpu-monitor />

        <div class="header-spacer"></div>
        <div class="header-actions">
          <!-- 返回主页按钮 -->
          <div class="home-btn" @click="gohome">
            <span class="iconfont">&#xe632;</span>
            <span>返回主页</span>
          </div>
          <!-- 生图记录按钮 -->
          <div class="header-btn" @click="handleGoToImageLog">
            <span class="iconfont">&#xe605;</span>
            <span>生图记录</span>
          </div>
          <!--支持与反馈按钮 -->
          <div class="header-btn" @click="handleOpenFeedback">
            <span class="iconfont">&#xe67c;</span>
            <span>支持与反馈</span>
          </div>
          <!-- 用户头像 -->
          <div class="user-avatar">
            <img :src="avatar" alt="待加载">
          </div>
        </div>
      </div>
    </header>
    <div class="body">
      <div class="content-wrapper">
        <!-- 左侧:上传图片 -->
        <div class="upload-section">
          <div class="upload-card">
            <div class="section-title">上传图片</div>
            <div class="upload-area" @click="handleImageUploadClick" @dragover.prevent @drop="handleImageDrop"
              v-loading="loading">
              <div v-if="imagePath" class="close-btn" @click.stop="deleteImage">×</div>
              <div v-if="!imagePath" class="upload-placeholder">
                <div class="upload-icon">📷</div>
                <div class="upload-text">拖拽图片或点击上传</div>
                <div class="upload-button">上传</div>
              </div>
              <img v-if="imagePath" :src="imagePath" alt="" class="uploaded-image">
            </div>
            <div class="upload-tips">
              <div class="tip-item">
                <span class="tip-label">文件大小:</span>
                <span class="tip-value">1400px及以下</span>
              </div>
              <div class="tip-item">
                <span class="tip-label">文件格式:</span>
                <span class="tip-value">常规图片格式</span>
              </div>
              <div class="tip-desc">支持人物、物品、手图类图像的高清处理。</div>
              <div class="tip-desc">如有问题请回到首页查看使用指南或<span class="link-text" @click="show_video">点击观看操作视频</span>。</div>
            </div>
          </div>
        </div>

        <!-- 右侧:输出图片 -->
        <div class="output-section">
          <div class="output-card">
            <div class="section-title">输出图片</div>
            <div class="output-area">
              <div v-if="processedImage" class="close-btn" @click.stop="clearOutput">×</div>
              <div v-if="!processedImage && !tips" class="output-placeholder">
                <div class="output-icon">🖼️</div>
                <div class="output-text">在线生图</div>
              </div>
              <img v-if="processedImage" :src="processedImage" alt="" class="output-image">
              <div v-if="tips" class="processing-mask">
                <div class="processing-text">{{ tips }}</div>
              </div>
            </div>
            <div class="output-tips">
              <div class="tip-item">
                <div class="action-btn" @click="handleUpscale">智能裁剪</div>
                <div class="action-btn" @click="handleInpaint">局部重绘</div>
              </div>
              <div class="tip-desc">如需对图像进行局部编辑，请选择智能裁剪。</div>
              <div class="tip-desc">对于图中不满意的部分可进行局部重绘。</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 底部操作栏 -->
      <div class="bottom-actions">
        <div class="help-btn" @mouseenter="showHelpTip = true" @mouseleave="showHelpTip = false">
          使用说明
          <div v-if="showHelpTip" class="help-tooltip">
            <div class="tooltip-title">高清放大使用说明</div>
            <div class="tooltip-content">
              <div class="tip-section">
                <p>为了获得更好的高清放大效果,请注意以下要点:</p>
                <div class="section-title">通用提醒:</div>
                <p>建议上传分辨率在1400×1400以内的图片,以确保最佳处理效果。</p>
              </div>
              <div class="tip-section">
                <div class="section-title">关于图片类型:</div>
                <p>1. 人物图像:效果较好,能有效提升清晰度和细节。</p>
                <p>2. 物品图像:支持高清放大,质量提升明显。</p>
                <p>3. 手图类图像:效果因图而异,建议多次尝试。</p>
              </div>
              <div class="tip-section">
                <div class="section-title">处理时间:</div>
                <p>预计等待时间为30-50秒,请耐心等待处理完成。</p>
              </div>
            </div>
          </div>
        </div>
        <div class="generate-btn" @click="start_process">生成图片</div>
        <div class="save-btn" @click="handleSave">保存图片</div>
      </div>
    </div>
    <ImageModal class="modal" :visible="isModalVisible" :img_url="imageUrl" @update:visible="isModalVisible = $event"
      :img_show="false" :video_show="true" :video_src="video_src"></ImageModal>
    <discussion-board class="discussion-board" :boardvisible="boardvisible" :disscussType="disscussType"
      @update:boardvisible="boardvisible = $event"></discussion-board>
  </div>
</template>
<script>
import { genOssImage } from '@/utils/ossPath'
import { v4 as uuidv4 } from 'uuid'
import random from 'random'
import { Message } from 'element-ui'
import { genPrompt } from '@/api/prompt'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import { getOssClient } from '@/utils/oss'
import localStorageUtils from '@/utils/setLocalStorage'
import { getTaskEnd, getTaskStart } from '@/api/user'
import { T_QUALITY_OPT } from '@/enums/common/modules'
import { getImageSizeByLoading } from '@/utils/helper/function'
import getImageDimensions from '@/utils/getImageDimensions'
import theme from '@/utils/theme'
import { mapGetters } from 'vuex'
import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET } from '@/utils/secretCrypto'
export default {
  name: 'RealisticHD',
  computed: {
    ...mapGetters(['avatar'])
  },
  data() {
    return {
      taskLogId: '',
      value: false,
      imageSrc: '',
      imagePath: '',
      processedImage: '',
      tips: false,
      current: '',
      processing: false,
      websocket: null,
      ws: null,
      clientId: '',

      loading: false,
      day: theme.day,
      night: theme.night,
      theme: true,
      // 防呆设计
      isModalVisible: false,
      imageUrl: '',
      img_show: false,
      video_src: '',
      // 评论区弹窗
      boardvisible: false,
      disscussType: null,
      // 新增字段
      showHelpTip: false // 控制帮助气泡显示
    }
  },
  created() {
    this.imagePath = localStorageUtils.getItem('realhd')
    this.processedImage = localStorageUtils.getItem('realhd_showimage')
    // 将ID值赋给讨论区类型
    this.disscussType = T_QUALITY_OPT
    // 获取主题
    if (localStorageUtils.getItem('theme') !== null) {
      this.theme = localStorageUtils.getItem('theme')
    } else {
      this.theme = true
    }
  },
  mounted() {
    // 添加键盘事件监听器
    window.addEventListener('keydown', this.handleKeystart)
    window.addEventListener('keydown', this.handleKeyPaste)
    // 重刷新释放cuda
    window.addEventListener('beforeunload', this.releaseCuda)
    this.$nextTick(() => {
      this.source_html()
    })
  },
  async beforeDestroy() {
    // 移除键盘事件监听器以防止内存泄漏
    window.removeEventListener('keydown', this.handleKeystart)
    window.removeEventListener('keydown', this.handleKeyPaste)
    try {
      // 释放cuda状态
      const index = await cudaIndexNum()
      if (index) {
        await cuda.changeCudaCurrentStatus(index, 'leisure')
        console.log('current cuda is leisure')
      }
    } catch (e) {
      console.log('no cuda is running')
    }
    // 移除cuda释放监听器
    window.removeEventListener('beforeunload', this.releaseCuda)
  },
  methods: {
    // 返回主页
    gohome() {
      this.$router.push({ path: '/' })
    },
    // 跳转到生图记录页面
    handleGoToImageLog() {
      const targetPath = '/userimagelog'
      if (this.$router.history.current.fullPath !== targetPath) {
        this.$router.push({ path: targetPath })
      }
    },
    // 打开支持与反馈(讨论区)
    handleOpenFeedback() {
      this.boardvisible = true
    },
    // 修改dissboard的状态
    handelDissvisible(x) {
      if (x === 1) {
        this.boardvisible = true
      }
      if (x === 2) {
        Message.warning('😋开发者功能暂未开放,敬请期待~!')
      }
    },
    // 释放cuda
    async releaseCuda() {
      try {
        // 释放cuda状态
        const index = await cudaIndexNum()
        if (index) {
          await cuda.changeCudaCurrentStatus(index, 'leisure')
          console.log('current cuda is leisure')
        }
      } catch (e) {
        console.log('no cuda is running')
      }
    },
    // 防呆设计
    show_video(event) {
      event.preventDefault()
      event.stopPropagation()
      this.isModalVisible = true
      this.video_src = 'https://mj-uploads.oss-cn-shenzhen.aliyuncs.com/public/aiDesign/web/wan_move_show_video/AI%E4%B8%80%E9%94%AE%E8%B6%85%E6%B8%85.mp4'
    },
    // 复制图像地址

    // 添加开始快捷键
    handleKeystart(event) {
      // 检查是否按下了 Ctrl + D
      if (event.ctrlKey && event.key === 'Enter') {
        event.preventDefault() // 阻止默认行为（可选）
        this.start_process() // 执行返回主页的操作
      }
    },
    warningTips() {
      Message.warning('由于浏览器安全协议,请使用Ctrl + V 快捷键进行图片粘贴')
    },
    // 添加 Ctrl+V 快捷键处理
    async handleKeyPaste(event) {
      // 检查是否按下了 Ctrl + V
      if (event.ctrlKey && event.key === 'v') {
        // event.preventDefault()
        try {
          const textarea = document.createElement('textarea')
          textarea.style.position = 'fixed'
          textarea.style.opacity = '0'
          document.body.appendChild(textarea)
          textarea.focus()
          // 创建一个Promise来等待粘贴事件完成
          const clipboardData = await new Promise((resolve, reject) => {
            textarea.addEventListener('paste', () => {
              setTimeout(() => {
                resolve(textarea.value)
              }, 10)
            })
            // 设置超时，防止永远等待
            setTimeout(() => {
              reject(new Error('粘贴操作超时'))
            }, 2000)
          })
          document.body.removeChild(textarea)
          // 使用正则表达式判断字符串是否以常见图片格式结尾
          const imageRegex = /\.(png|jpe?g|gif|bmp|webp)$/i
          if (!imageRegex.test(clipboardData)) {
            Message.error('剪切板中的内容不是有效的图片地址（支持的格式：.png, .jpg, .jpeg, .gif, .bmp, .webp)')
          } else {
            // console.log(clipboardData)
            this.imagePath = clipboardData
            localStorageUtils.setItem('realhd', clipboardData)
            Message.success('已从剪切板粘贴图片地址')
          }
        } catch (err) {
          Message.error('出现系统兼容性错误,请上报错误给开发者!')
        }
      }
    },
    // 上传图片到OSS
    async uploadToOSS(file, ossClient) {
      const tmp = '/input/'
      const fileName = file.name
      console.log('上传到OSS:', tmp + fileName)
      try {
        const result = await ossClient.put(tmp + fileName, file)
        return result.url
      } catch (err) {
        return null
      }
    },
    // 点击上传按钮
    handleImageUploadClick() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'image/*'
      input.onchange = (event) => {
        const file = event.target.files[0]
        if (file) {
          this.processImage(file)
        }
      }
      input.click()
    },
    // 拖拽上传事件
    handleImageDrop(event) {
      event.preventDefault()
      const file = event.dataTransfer.files[0]
      if (file && file.type.startsWith('image/')) {
        this.processImage(file)
      } else {
        Message.error('请上传有效的图片文件')
      }
    },
    //  图片处理函数
    async processImage(file) {
      this.loading = true
      const ossClient = await getOssClient()
      // 上传图片到OSS
      const imageUrl = await this.uploadToOSS(file, ossClient)
      // 获取图片尺寸并加以限制
      try {
        const imageSize = await getImageDimensions(imageUrl)
        // console.log('图片尺寸:', imageSize.width, 'x', imageSize.height)
        if (imageSize.width > 1400 || imageSize.height > 1400) {
          Message.error('图片尺寸过大,请重新上传!建议分辨率为1400*1400以内')
          this.loading = false
          return
        }
      } catch (error) {
        Message.error('获取图片尺寸失败:', error)
      }
      if (imageUrl) {
        this.imagePath = imageUrl // 更新图片路径为OSS的URL
        console.log(imageUrl, typeof imageUrl)
        localStorageUtils.setItem('realhd', imageUrl)
        Message.success('图片加载成功,可以准备开始任务!')
      } else {
        Message.error('图片上传失败,请检查网络配置!')
      }
      // 同时显示本地预览
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageSrc = e.target.result
      }
      reader.readAsDataURL(file)
      this.loading = false
    },
    deleteImage() {
      this.imagePath = ''
      this.processing = false
      this.tips = false
      localStorage.removeItem('realhd')
      localStorage.removeItem('realhd_showimage')
    },
    // 清空输出图片
    clearOutput() {
      this.processedImage = ''
      this.processing = false
      this.tips = false
      localStorage.removeItem('realhd_showimage')
    },
    // 高清放大功能(占位)
    handleUpscale() {
      Message.warning('😋开发者功能暂未开放,敬请期待~!')
    },
    // 局部重绘功能(占位)
    handleInpaint() {
      Message.warning('😋开发者功能暂未开放,敬请期待~!')
    },
    // 保存功能(下载图片)
    async handleSave() {
      if (!this.processedImage) {
        Message.warning('😋请先生成图片,然后再进行保存~!')
        return
      }
      try {
        Message.info('正在下载图片...')
        // 获取图片数据
        const response = await fetch(this.processedImage)
        const blob = await response.blob()
        // 创建一个隐藏的a标签进行下载
        const link = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        link.href = url
        // 生成文件名:使用时间戳
        const timestamp = new Date().getTime()
        link.download = `realistic_hd_${timestamp}.png`
        // 执行下载
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        // 释放内存
        window.URL.revokeObjectURL(url)
        Message.success('图片保存成功!')
      } catch (error) {
        console.error('保存图片失败:', error)
        Message.error('保存图片失败,请稍后再试!')
      }
    },
    // 应用函数
    start_process() {
      this.processedImage = ''
      if (this.imagePath === '' || this.imagePath === null) {
        Message.warning('请先选择图像文件')
        return
      }
      if (this.processing) {
        Message.warning('任务已在进行中，请勿重复提交以免造成错误!')
        return
      }
      this.processing = true
      this.tips = '任务正在生成,预计等待30-50S.....'
      const seed = Math.floor(Math.random() * 10000000000000000)
      const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
      const promptData = {
        15: {
          inputs: {
            upscale_by: [
              '26',
              0
            ],
            seed: seed,
            steps: 4,
            cfg: 1,
            sampler_name: 'euler',
            scheduler: 'beta',
            denoise: [
              '40',
              0
            ],
            mode_type: 'Linear',
            tile_width: 1024,
            tile_height: 1024,
            mask_blur: 30,
            tile_padding: 32,
            seam_fix_mode: 'None',
            seam_fix_denoise: 1,
            seam_fix_width: 64,
            seam_fix_mask_blur: 8,
            seam_fix_padding: 16,
            force_uniform_tiles: true,
            tiled_decode: false,
            image: [
              '230',
              0
            ],
            model: [
              '22',
              0
            ],
            positive: [
              '18',
              0
            ],
            negative: [
              '20',
              0
            ],
            vae: [
              '21',
              0
            ],
            upscale_model: [
              '17',
              0
            ]
          },
          class_type: 'UltimateSDUpscale'
        },
        17: {
          inputs: {
            model_name: '4x_NMKD-Siax_200k.pth'
          },
          class_type: 'UpscaleModelLoader'
        },
        18: {
          inputs: {
            text: [
              '19',
              2
            ],
            clip: [
              '44',
              0
            ]
          },
          class_type: 'CLIPTextEncode'
        },
        19: {
          inputs: {
            text_input: '',
            task: 'detailed_caption',
            fill_mask: true,
            keep_model_loaded: false,
            max_new_tokens: 1024,
            num_beams: 3,
            do_sample: true,
            output_mask_select: '',
            seed: seed,
            image: [
              '230',
              0
            ],
            florence2_model: [
              '51',
              0
            ]
          },
          class_type: 'Florence2Run'
        },
        20: {
          inputs: {
            text: '',
            clip: [
              '44',
              0
            ]
          },
          class_type: 'CLIPTextEncode'
        },
        21: {
          inputs: {
            vae_name: 'ae.safetensors'
          },
          class_type: 'VAELoader'
        },
        22: {
          inputs: {
            strength: 1,
            model: [
              '50',
              0
            ]
          },
          class_type: 'DifferentialDiffusion'
        },
        26: {
          inputs: {
            value: '3'
          },
          class_type: 'Float'
        },
        40: {
          inputs: {
            value: '0.23'
          },
          class_type: 'Float'
        },
        43: {
          inputs: {
            unet_name: 'FLUX1/flux1-dev-fp8.safetensors',
            weight_dtype: 'fp8_e4m3fn'
          },
          class_type: 'UNETLoader'
        },
        44: {
          inputs: {
            clip_name1: 't5xxl_fp8_e4m3fn.safetensors',
            clip_name2: 'clip_l.safetensors',
            type: 'flux',
            device: 'default'
          },
          class_type: 'DualCLIPLoader'
        },
        50: {
          inputs: {
            lora_name: '【人像大师】真实感亚洲人像写真_v1.0.safetensors',
            strength_model: 0.7,
            model: [
              '43',
              0
            ]
          },
          class_type: 'LoraLoaderModelOnly'
        },
        51: {
          inputs: {
            model: 'microsoft/Florence-2-base',
            precision: 'fp16',
            attention: 'sdpa',
            convert_to_safetensors: false
          },
          class_type: 'DownloadAndLoadFlorence2Model'
        },
        230: {
          inputs: {
            image_url: this.imagePath
          },
          class_type: 'LoadImageFromURL'
        },
        231: {
          inputs: {
            filename: filename,
            access_key_id: OSS_ACCESS_KEY_ID,
            access_key_secret: OSS_ACCESS_KEY_SECRET,
            security_token: '',
            bucket_name: 'mj-comfy-ui',
            endpoint: 'oss-cn-shenzhen.aliyuncs.com',
            image: [
              '15',
              0
            ]
          },
          class_type: 'OSSUploadNode'
        }
      }
      this.clientId = uuidv4()
      const data = {
        prompt: promptData,
        client_id: this.clientId
      }
      // 发送 Prompt 请求
      const sendPromptRequest = async () => {
        try {
          console.log('get prompt response', data)
          return await genPrompt(data)
        } catch (error) {
          console.error('发送作图请求失败：', error)
          // 判断error.response是否存在，避免空值访问
          if (error.response) {
            // 有响应体的情况
            const status = error.response.status
            const errorData = error.response.data
            console.error('请求失败详情：', { status, errorData })
            if (status === 400) {
              Message.error('请求参数错误(400)，请检查输入参数是否正确')
            }
          } else if (error.request) {
            // 请求已发出但没有收到响应（如CORS、网络错误）
            console.error('网络错误或CORS拦截，请在浏览器Network面板查看详情')
            Message.error('网络连接异常，请检查网络或查看控制台')
          } else {
            // 其他错误
            console.error('请求配置错误：', error.message)
            Message.error('请求配置错误，请联系开发者')
          }
          this.processing = false
          this.tips = false
          return null
        }
      }

      const fetchImageFilename = async (promptId) => {
        try {
          // 直接使用该实例请求历史记录
          const historyRequest = axios.create({
            baseURL: getLastUsedBaseUrl(),
            timeout: 5000,
            headers: {
              'Content-Type': 'application/json'
            }
          })

          const response = await historyRequest.get(`/history/${promptId}`)
          const promptInfo = response.data[promptId]
          // const response = await getImagePathByPrompt(promptId)
          // const promptInfo = response[promptId]
          const promptIndex = 2 // prompt信息的下标
          const inputIndex = 231 // prompt信息组件名的下标(OSSUploadNode节点ID)

          console.log(promptInfo)
          if (promptInfo && promptInfo.status && promptInfo.status.status_str === 'success') {
            const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)

            const imagepath = genOssImage(tmp[0])
            localStorageUtils.setItem('realhd_showimage', imagepath)
            this.getTaskEnd(imagepath, this.taskLogId)
            this.processedImage = imagepath
            this.processing = false
            this.tips = false
          } else {
            console.error('任务执行失败或状态异常：', promptInfo)
            Message.error('图像生成失败，请重试')
            this.processing = false
            this.tips = false
          }
        } catch (error) {
          console.error('获取图像文件名失败：', error)
          // 判断error.response是否存在
          if (error.response) {
            console.error('响应错误详情：', error.response.status, error.response.data)
            Message.error(`获取结果失败(${error.response.status})，请重试`)
          } else if (error.request) {
            console.error('请求无响应，请检查网络或查看Network面板')
            Message.error('网络异常，无法获取结果')
          } else {
            Message.error('获取结果失败，请重试')
          }
          this.processing = false
          this.tips = false
        }
      }

      const listenToProgress = (promptId) => {
        this.ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${this.clientId}`)
        const wsTimeout = setTimeout(() => {
          Message.warning('网络连接超时,请重新尝试!')
          this.ws.close()
        }, 2000)

        this.ws.onopen = () => {
          console.log('提交服务器开始生成...')
          getTaskStart({
            type: T_QUALITY_OPT
          }).then(rep => {
            this.taskLogId = rep.data.task.id
          })
          clearTimeout(wsTimeout)
        }
        this.ws.onmessage = async (event) => {
          clearTimeout(wsTimeout)
          const data = event.data
          if (typeof data === 'string') {
            try {
              const msg = JSON.parse(event.data)
              console.log(`这是返回${msg}`)

              if (msg.type === 'executing') {
                const data = msg.data
                if (data.node === null && data.prompt_id === promptId) {
                  // console.log('执行完成')
                  this.ws.close()
                  await fetchImageFilename(promptId)
                }
              } else if (msg.type === 'progress') {
                const value = msg.data.value
                const max = msg.data.max
                const current = (value / max * 100).toFixed(2)
                this.tips = `大约完成：${current}%`
              }
            } catch (error) {
              console.log('获取结果失败，请重试')
              this.tips = false
            }
          }
        }
        this.ws.onclose = async () => {
          // console.log('与后台链接断开')
          this.processing = false
          this.tips = false
          try {
            // 恢复cuda为空闲状态
            const index = cudaIndexNum()
            // console.log('回复当前cuda状态', index)
            await cuda.changeCudaCurrentStatus(index, 'leisure')
          } catch (error) { console.log(error) }
        }
      }

      (async () => {
        const result = await sendPromptRequest()
        if (result && result.prompt_id) {
          listenToProgress(result.prompt_id)
        }
      })()
    },
    async getTaskEnd(tmp, taskLogId) {
      const imgInfo = await getImageSizeByLoading(tmp)
      const info = {
        details: [{ path: tmp, imgInfo: imgInfo }]
      }
      getTaskEnd({ result: JSON.stringify(info) }, taskLogId)
    },
    // 初始化效果
    source_html() {
      const main = document.querySelector('.content-wrapper')
      if (main) {
        main.style.opacity = this.theme === false ? 0.75 : 1
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "@/style/common.less";
@import "@/assets/fonts/style.css";
@import "@/assets/font_sczlgzino/iconfont.css";

@keyframes ip_move {
  0% {
    padding-bottom: 5px;
  }

  50% {
    padding-bottom: 10px;
  }

  100% {
    padding-bottom: 5px;
  }
}

@keyframes opacity {
  0% {
    opacity: 0.4;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0.4;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  font-family: "icomoon";
  overflow: hidden;
}

.active {
  transition: all 0.5s;
  background-color: @basicselect;
  color: @font_black;
}

.el-message--warning {
  background-color: #fff3cd !important;
  color: #856404 !important;
  border: 1px solid #ffeeba !important;
  font-weight: bold;
}

.iconfont {
  font-family: "iconfont" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 25px;
}

.app-container {
  width: 100vw;
  height: 100vh;
  background: #f5f7fa;
  overflow: hidden;
}

// Header样式
header {
  height: 95px;
  width: 100%;
  padding: 10px 30px;
  font-family: "icomoon";
  font-size: 18px;
  border-bottom: 1px solid #e5e7eb;
  background: white;

  .header-content {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .logo-section {
    width: 230px;
    height: 75px;
    display: flex;
    align-items: center;
    padding: 10px;

    img {
      width: 230px;
      object-fit: cover;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        transform: scale(1.05);
      }
    }
  }

  .header-spacer {
    flex: 1;
  }

  .header-actions {
    display: flex;
    gap: 20px;
    align-items: center;

    .home-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: #ff8c42;
      color: white;
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;

      .iconfont {
        font-size: 20px;
      }

      &:hover {
        background-color: #ff7a2e;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }
    }

    .header-btn {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 24px;
      border-radius: 10px;
      background-color: rgba(39, 41, 46, 0.05);
      cursor: pointer;
      transition: all 0.3s;
      font-size: 16px;
      color: #333;
      white-space: nowrap;

      .iconfont {
        font-size: 20px;
      }

      &:hover {
        background-color: #f0f0f0;
        transform: translateY(-2px);
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
      }
    }

    .user-avatar {
      display: flex;
      width: 50px;
      height: 50px;
      border: 2px solid #e5e7eb;
      border-radius: 50%;
      overflow: hidden;
      justify-content: center;
      align-items: center;

      img {
        cursor: pointer;
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: all 0.3s;

        &:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}

.body {
  width: 100vw;
  height: calc(100vh - 95px);
  background: #ffffff;
  padding: 40px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: @basicselect transparent;

  .content-wrapper {
    display: flex;
    gap: 50px;
    max-width: 1600px;
    margin: 0 auto;
    height: calc(100% - 140px);
  }

  // 上传区域和输出区域通用样式
  .upload-section,
  .output-section {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .section-title {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }

  .upload-card,
  .output-card {
    background: white;
    border-radius: 30px;
    padding: 30px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
    height: 600px; /* 固定卡片高度 */
  }

  // 上传区域样式
  .upload-area {
    position: relative;
    flex: 1;
    background: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    overflow: hidden;
    min-height: 400px;
    height: 400px; /* 固定高度 */

    &:hover {
      border-color: #ff8c42;
      background: #fff8f3;
    }

    .close-btn {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 32px;
      height: 32px;
      background: rgba(0, 0, 0, 0.5);
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s;

      &:hover {
        background: rgba(255, 0, 0, 0.8);
        transform: scale(1.1);
      }
    }

    .upload-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;

      .upload-icon {
        font-size: 60px;
      }

      .upload-text {
        font-size: 16px;
        color: #6c757d;
      }

      .upload-button {
        padding: 10px 30px;
        background: #ff8c42;
        color: white;
        border-radius: 25px;
        font-size: 16px;
        transition: all 0.3s;

        &:hover {
          background: #ff7a2e;
          transform: translateY(-2px);
        }
      }
    }

    .uploaded-image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .upload-tips {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 14px;
    color: #6c757d;

    .tip-item {
      display: flex;
      gap: 5px;

      .tip-label {
        font-weight: 600;
        color: #495057;
      }

      .tip-value {
        color: #ff8c42;
      }
    }

    .tip-desc {
      line-height: 1.6;
      color: #868e96;

      .link-text {
        color: #ff8c42;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
          color: #ff7a2e;
        }
      }
    }
  }

  // 输出区域样式
  .output-area {
    position: relative;
    flex: 1;
    background: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    min-height: 400px;
    height: 400px; /* 固定高度 */

    .close-btn {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 32px;
      height: 32px;
      background: rgba(0, 0, 0, 0.5);
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      cursor: pointer;
      z-index: 10;
      transition: all 0.3s;

      &:hover {
        background: rgba(255, 0, 0, 0.8);
        transform: scale(1.1);
      }
    }

    .output-placeholder {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;

      .output-icon {
        font-size: 60px;
        opacity: 0.3;
      }

      .output-text {
        font-size: 16px;
        color: #adb5bd;
      }
    }

    .output-image {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    .processing-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 5;

      .processing-text {
        font-size: 18px;
        color: #ff8c42;
        font-weight: 600;
      }
    }
  }

  // 输出提示区域样式
  .output-tips {
    display: flex;
    flex-direction: column;
    gap: 10px;
    font-size: 14px;
    color: #6c757d;

    .tip-item {
      display: flex;
      gap: 15px;

      .action-btn {
        flex: 1;
        padding: 12px;
        background: white;
        border: 2px solid #dee2e6;
        border-radius: 10px;
        text-align: center;
        font-size: 16px;
        color: #495057;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          border-color: #ff8c42;
          color: #ff8c42;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(255, 140, 66, 0.2);
        }
      }
    }

    .tip-desc {
      line-height: 1.6;
      color: #868e96;
    }
  }

  // 底部操作栏
  .bottom-actions {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
    margin-top: 70px;
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;

    .generate-btn {
      padding: 12px 100px;
      background: #ff8c42;
      color: white;
      border-radius: 30px;
      font-size: 18px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 15px rgba(255, 140, 66, 0.3);

      &:hover {
        background: #ff7a2e;
        transform: translateY(-2px);
        box-shadow: 0 6px 15px rgba(255, 140, 66, 0.6);
      }

      &:active {
        transform: translateY(0);
      }
    }

    .save-btn,
    .copy-btn {
      padding: 12px 40px;
      background: white;
      color: #ff8c42;
      border: 2px solid #ff8c42;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: #ff8c42;
        color: white;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }
    }

    .help-btn {
      position: relative;
      padding: 12px 40px;
      background: white;
      color: #a5a5a5;
      border: 2px solid #c7c7c7;
      border-radius: 30px;
      font-size: 16px;
      font-weight: 500;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: #ff8c42;
        color: white;
        border: 2px solid #ff8c42;
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(255, 140, 66, 0.3);
      }

      .help-tooltip {
        position: absolute;
        bottom: 70px;
        right: 0;
        width: 650px;
        max-height: 1000px;
        overflow-y: auto;
        background: white;
        border-radius: 15px;
        padding: 25px;
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
        z-index: 1000;
        animation: fadeInUp 0.3s ease;

        &::after {
          content: '';
          position: absolute;
          bottom: -10px;
          right: 15px;
          width: 0;
          height: 0;
          border-left: 10px solid transparent;
          border-right: 10px solid transparent;
          border-top: 10px solid white;
        }

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 3px;
        }

        &::-webkit-scrollbar-thumb {
          background: #ff8c42;
          border-radius: 3px;

          &:hover {
            background: #ff7a2e;
          }
        }

        .tooltip-title {
          font-size: 20px;
          font-weight: 600;
          color: #333;
          margin-bottom: 20px;
          padding-bottom: 12px;
          border-bottom: 2px solid #ff8c42;
        }

        .tooltip-content {
          font-size: 14px;
          line-height: 1.8;
          color: #555;

          .tip-section {
            margin-bottom: 20px;

            &:last-child {
              margin-bottom: 0;
            }

            .section-title {
              font-size: 16px;
              font-weight: 600;
              color: #ff8c42;
              margin-bottom: 10px;
            }

            p {
              margin: 8px 0;
              padding-left: 10px;
              color: #666;
            }
          }
        }
      }
    }
  }
}
</style>
